export default {
    SPECIALIST(state, response) {
        if (response.status == 200) {
            state.specialist = response.data.specialist;
            state.specialist.articles_display = response.data.articles.slice(0, 3);
            state.specialist.categories = response.data.tags;
            state.specialist.timetable = response.data.timetable;
            state.specialist.feedback_grade = response.data.feedback_grade;
            state.specialist.feedback_graph = response.data.feedback_graph;
            state.metadata = response.data.metadata;
            state.packages = response.data.packages;
            state.articles.count = Object.keys(response.data.articles).length;
            state.articles.display = response.data.articles.slice(0, 3);
            state.reviews.all = response.data.all_reviews;
            state.reviews.canAdd = response.data.can_review;
            // state.reviews.canAdd = true;
            state.reviews.count = Object.keys(response.data.all_reviews).length;
            // state.reviews.display = response.data.all_reviews.slice(0, 3);

            for (let index = 0; index <= 3; index++) {
                state.reviews.display[index] = response.data.all_reviews[index];
            }
            
            state.reviews.grade = response.data.feedback_grade?response.data.feedback_grade:'0.0';
            state.reviews.graph = response.data.feedback_graph;

            if (localStorage.getItem('role') == 'client') {
                if (response.data.can_review && !(response.data.specialist.given_review)) {
                    state.reviews.canAdd = true;
                }
                state.userServices = response.data.user.available_services_specialist;
            }
        }
    },
    // STATUS 1: push -> add services to userServices object
    // STATUS 2: remove -> remove services to userServices object
    // STATUS 3: replace -> replace userServices
    UPDATE_USER_SERVICES(state, data) {
        switch (data.type) {
            case 'push': {
                data.services.forEach(service => {
                    state.userServices.push(service);
                });
                break;
            }
            case 'remove': {
                // data.services.forEach(service => {
                //     state.userServices.push(service);
                // });
                break;
            }
            case 'replace': {
                state.userServices = data.services;
                break;
            }
        }
    },

    STORE_FEEDBACK(state, response) {
        response.data.review.approved = 0;
        state.reviews.all.unshift(response.data.review);
        state.reviews.display.unshift(response.data.review);
        state.reviews.count++;
        state.reviews.canAdd = false;
        state.modals.addFeedback = false;
    },
    UPDATE_FEEDBACK_GRAPH(state, response) {
        state.reviews.all = response.data.reviews_all
        state.reviews.display = response.data.reviews_display
        state.reviews.count = response.data.reviews_all.length;

        state.reviews.grade = response.data.feedback_grade;
        state.reviews.graph = response.data.feedback_graph;

        state.specialist.feedback_grade = response.data.feedback_grade;
        state.specialist.feedback_graph = response.data.feedback_graph;

        if (localStorage.getItem('role') == 'client')
            state.reviews.canAdd = response.data.can_review;
    },

  /* Booking */
  AVAILABILITY_DATES(state, data) {
    state.booking.selectedDayIndex = 0;
    state.booking.selectedStartTime = null;
    state.booking.selectedEndTime = null;

    if (data === null) {
      return state.booking.availabilityDates = null;
    }

    let isFull = true;

    for (const availability of data.availability_dates) {
      if (availability.availabilitiesCount !== 0) {
        isFull = false;
      }
    }

    if (isFull) {
      state.booking.availabilityDates = [];
      return;
    }

    state.booking.availabilityDates = data.availability_dates;

    for (const availability of data.availability_dates) {
      if (availability.availabilitiesCount !== 0) {
        break;
      }

      state.booking.selectedDayIndex++;
    }

    /*
    state.booking.availabilityDates = data.availability_dates.filter(
      availability => availability.availabilitiesCount !== 0
    );
    */
  },

  CLEAR_BOOKING(state) {
    state.booking = {
      loading: false,
      active: false,
      specialistId: null,
      currentStep: 1,
      servicesNumber: 1,
      availabilityDates: null,
      selectedStartTime: null,
      selectedEndTime: null,
      selectedDayIndex: null,
      summary: {
        money: 0,
        credits: 0,
        services: 0
      }
    }
  },

  LOADING_BOOKING(state, data) {
    state.booking.loading = data;
  },


  /* Transactions */
  TRANSACTIONS(state, data) {
    state.transactions = state.transactions.concat(data);
    state.transactionsLoading = false;
  },

  TRANSACTIONS_APPEARANCE(state, data) {
    state.transactionsAppearance = data;
  },
}
